import psdImg from '../../assets/images/LH-Banner_Template-1.png'
import psdImg2 from '../../assets/images/LH-Banner_Template_2-2.png'


import React from 'react'

const openMailComposer = () => {
    window.location.href = "mailto:info@languagehelpersllc.com";
};

const PsBanner = () => {
  return (
    <div className="general-contaner" style={{ background: "#1c1925" }}>
        <div className="phoneView pt-7 mx-auto max-w-7xl px-4 sm:px-6 lg:px-1">
          <img src={psdImg2} alt="" />
          <div className="banner-cover">
            <a onClick={openMailComposer} className="apply-now">Apply Now</a>
          </div>
        </div>

        <div className="pcView mx-auto max-w-7xl px-4 sm:px-6 lg:px-1">
          <img src={psdImg} alt="" />
          <div className="banner-cover">
            <a onClick={openMailComposer} className="apply-now">Apply Now</a>
          </div>
        </div>
    </div>
  )
}

export default PsBanner